export default __webpack_public_path__ + "static/media/wyndham3.5f11a379.png";